import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  className?: string;
}
export function Tabs({
  tabs,
  defaultTab,
  className = ''
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);
  return <div className={className} data-id="element-341">
      <div className="border-b border-slate-200" data-id="element-342">
        <nav className="flex gap-1 -mb-px" role="tablist" data-id="element-343">
          {tabs.map(tab => <button key={tab.id} role="tab" aria-selected={activeTab === tab.id} aria-controls={`panel-${tab.id}`} onClick={() => setActiveTab(tab.id)} className={`
                relative px-4 py-3 text-sm font-medium transition-colors
                ${activeTab === tab.id ? 'text-sky-600' : 'text-slate-500 hover:text-slate-700'}
              `} data-id="element-344">
              {tab.label}
              {activeTab === tab.id && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-sky-500" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-345" />}
            </button>)}
        </nav>
      </div>
      <div className="pt-6" data-id="element-346">
        {tabs.map(tab => <div key={tab.id} id={`panel-${tab.id}`} role="tabpanel" aria-labelledby={tab.id} hidden={activeTab !== tab.id} data-id="element-347">
            {activeTab === tab.id && <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-348">
                {tab.content}
              </motion.div>}
          </div>)}
      </div>
    </div>;
}